document.addEventListener("DOMContentLoaded", function () {
  console.log("🟢 Swatch script loaded");
  
  // Function to preload images
  function preloadImage(url) {
    if (!url) return;
    const img = new Image();
    img.src = url;
    console.log(`  ↳ Preloading image: ${url}`);
  }
  
  // Function to initialize swatches on product cards
  function initializeSwatches(cards) {
    console.log(`– Processing product cards: ${cards.length}`);
    cards.forEach((card, cardIndex) => {
      // Skip if already initialized
      if (card.dataset.swatchesInitialized === "true") return;
      
      const mainImage = card.querySelector(".main-product-image");
      const hoverImage = card.querySelector(".media--hover-effect img:not(.main-product-image)");
      const swatches = card.querySelectorAll(".swatch-color");
      const originalMainImage = mainImage && mainImage.getAttribute("src");
      const originalHoverImage = hoverImage && hoverImage.getAttribute("src");
      const originalHoverSrcset = hoverImage && hoverImage.getAttribute("srcset");
      let currentMainImage = originalMainImage;
      let currentHoverImage = originalHoverImage;
      let currentHoverSrcset = originalHoverSrcset;
      
      console.log(`• Card ${cardIndex}: mainImage?`, !!mainImage, `– hoverImage?`, !!hoverImage, `– swatches: ${swatches.length}`);
      
      if ((!mainImage && !hoverImage) || swatches.length === 0) return;
      
      swatches.forEach((swatch, i) => {
        const swatchImage = swatch.getAttribute("data-image");
        if (swatchImage) {
          preloadImage(swatchImage);
        }
        
        console.log(`  ↳ Attaching to swatch ${i}:`, swatch, "→", swatchImage);
        
        swatch.addEventListener("mouseover", function () {
          console.log(`    • mouseover on swatch ${i}`);
          if (swatchImage) {
            // Update main image
            if (mainImage) {
              mainImage.src = swatchImage;
              mainImage.removeAttribute('srcset');
            }
            
            // Update hover image
            if (hoverImage) {
              hoverImage.src = swatchImage;
              hoverImage.removeAttribute('srcset');
            }
          }
        });
        
        // swatch.addEventListener("mouseout", function () {
        //   console.log(`    • mouseout on swatch ${i}`);
        //   // Restore main image
        //   if (mainImage) {
        //     mainImage.src = currentMainImage;
        //     mainImage.removeAttribute('srcset');
        //   }
          
        //   // Restore hover image
        //   if (hoverImage) {
        //     hoverImage.src = currentHoverImage;
        //     if (currentHoverSrcset) {
        //       hoverImage.setAttribute('srcset', currentHoverSrcset);
        //     }
        //   }
        // });
        
        swatch.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          console.log(`    • click on swatch ${i}`);
          if (swatchImage) {
            // Update current images
            currentMainImage = swatchImage;
            currentHoverImage = swatchImage;
            currentHoverSrcset = ''; // Clear srcset on click
            
            // Apply to DOM
            if (mainImage) {
              mainImage.src = currentMainImage;
              mainImage.removeAttribute('srcset');
            }
            
            if (hoverImage) {
              hoverImage.src = currentHoverImage;
              hoverImage.removeAttribute('srcset');
            }
            
            console.log(`      ⇒ Images locked to ${currentMainImage}`);
          }
        });
      });
      
      // Mark this card as initialized
      card.dataset.swatchesInitialized = "true";
    });
  }
  
  // Initialize swatches on existing cards
  const existingCards = document.querySelectorAll(".product-card-wrapper");
  initializeSwatches(existingCards);
  
  // Set up mutation observer to watch for new product cards
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check for added nodes
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Look for product cards among added nodes and their descendants
        mutation.addedNodes.forEach(function(node) {
          // Check if the node itself is a product card
          if (node.classList && node.classList.contains('product-card-wrapper')) {
            initializeSwatches([node]);
          }
          
          // Check node's children for product cards
          if (node.querySelectorAll) {
            const newCards = node.querySelectorAll('.product-card-wrapper');
            if (newCards.length > 0) {
              initializeSwatches(newCards);
            }
          }
        });
      }
    });
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log("🟢 Mutation observer set up for dynamically loaded content");
});





